import {StoppageContent, StoppageSection, StoppageInfo} from '@domain/stoppages'
import ArrowForward from '@mui/icons-material/ArrowForward'
import Close from '@mui/icons-material/Close'
import LinkIcon from '@mui/icons-material/Link'
import {Box, Button, IconButton, Stack, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../localization'
import {formatDateTime} from '../utils'

export const StoppageDetail: React.FC<{
  stoppage: StoppageInfo
  closeAction: () => void
  moveToNextStep: (e) => void
  onLink?: () => void
  showNextStep?: boolean
}> = ({stoppage, closeAction, moveToNextStep, onLink, showNextStep = true}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const handleClose = (e) => {
    closeAction()
    e.stopPropagation()
  }

  return (
    <Stack spacing={2} sx={{maxHeight: '65vh', overflowY: 'auto'}}>
      {/* TITLE */}
      <Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Typography variant="h2" mb={1}>
            {t('stoppage.detail.stoppageDetail')}
          </Typography>
          <IconButton onClick={handleClose} color="primary">
            <Close />
          </IconButton>
        </Stack>
        <Typography variant="caption">
          {t('stoppage.detail.createdBy')} {stoppage.createdBy} {t('stoppage.detail.on')}{' '}
          {stoppage.createDate ? formatDateTime(stoppage.createDate) : ''}
        </Typography>
        <Typography variant="caption">
          {t('stoppage.detail.updatedBy')} {stoppage.updatedBy} {t('stoppage.detail.on')}{' '}
          {stoppage.updateDate ? formatDateTime(stoppage.updateDate) : ''}
        </Typography>
      </Stack>

      {/* ASSET & CODE */}
      <StoppageContent stoppage={stoppage} translationNamespace={FEATURE_NAMESPACE} />

      {/* EQUIPMENT */}
      <StoppageSection
        label={t('stoppage.detail.equipment')}
        value={stoppage?.equipment?.text}
        labelBottom={stoppage?.equipment?.id}
      />

      {/* DESCRIPTION */}
      <StoppageSection
        label={t('stoppage.detail.description')}
        value={stoppage?.description}
        valueProps={{variant: 'body1'}}
      />
      <Box display="flex" flexDirection="row" gap={2} justifyContent="flex-end">
        {onLink && (
          <Button
            color="secondary"
            variant="outlined"
            startIcon={<LinkIcon />}
            data-test-id="stoppage-link-button"
            onClick={() => onLink()}
            sx={{alignSelf: 'flex-end', width: 'fit-content', minHeight: '48px'}}
          >
            {t('stoppage.new.link')}
          </Button>
        )}
        {showNextStep && (
          <Button
            color="primary"
            variant="contained"
            startIcon={<ArrowForward />}
            data-test-id="create-analysis-continue-button"
            onClick={(e) => moveToNextStep(e)}
            sx={{alignSelf: 'flex-end', width: 'fit-content', minHeight: '48px'}}
          >
            {t('stoppage.new.analysis')}
          </Button>
        )}
      </Box>
    </Stack>
  )
}
